export default "__VITE_ASSET__CUkHU2IQ__"